var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-layout"},[_c('div',{attrs:{"id":"header"}},[_c('CadreHeader')],1),_c('div',{staticClass:"page-contents"},[_c('router-view'),_c('CadreFooterComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }